/**
 * Scrolls the main authenticated content area back to the top.
 *
 * The app shell does not scroll the window — `body`/`html` use
 * `overflow: hidden` and the scrollable region is the navbar's
 * `#right-section` container. Calling `window.scrollTo` therefore has no
 * effect, so this helper resets the actual scroll container (falling back to
 * the window for layouts that do scroll the document).
 */
export const scrollMainContentToTop = () => {
	const scrollContainer = document.querySelector("#right-section");
	if (scrollContainer) {
		scrollContainer.scrollTop = 0;
	} else {
		window.scrollTo(0, 0);
	}
};
